import { ON_RPM, ON_RUNNER } from '../consts.js';

import drawer from './state/drawer.js';
import network from './state/network.js';
import error from './state/error.js';
import success from './state/success.js';
import navigation from './state/navigation.js';
import properties from './state/properties.js';
import rmAccountData from './state/rmAccountData.js';
import rpmAccountData from './state/rpmAccountData.js';

const state = {
  drawer,
  network,
  error,
  success,
  navigation,
  properties,
};

if (ON_RUNNER) {
  state.rmAccountData = rmAccountData;
}

if (ON_RPM) {
  state.rpmAccountData = rpmAccountData;
}

export default state;
